import styled from '@emotion/styled';
import { size } from './defaults';
import arrow from '../svg/arrow.svg';

export const MainWrapper = styled.div`
  display: flex;
  align-items: center;

  .DayPickerKeyboardShortcuts_buttonReset {
    display: none;
  }

  .DateInput {
    width: 7rem !important;
    height: 100%;

    .DateInput_input {
      height: 100%;
      padding: ${size(4)} ${size(16)};
      font-size: ${size(14)};

      &:focus,
      &.DateInput_input__focused {
        border-color: ${props => `${props.styles.selectedColor}`};
      }
    }
  }

  .DateRangePickerInput.DateRangePickerInput__withBorder {
    border: ${props => `1px solid ${props.styles.borderColor}`};
    border-radius: 1px;
    height: ${size(32)};
  }

  .DateRangePickerInput_arrow {
    font-size: 0;

    &::before {
      content: 'To';
      font-size: ${size(14)};
    }
  }

  .DayPicker {
    > div {
      display: flex;
    }

    .DayPickerNavigation {
      .DayPickerNavigation_button {
        outline: none !important;
        border: none;
        width: ${size(24)};
        height: ${size(32)};
        background: url(${arrow}) no-repeat center;
        background-origin: content-box;
        padding: 6px;

        svg {
          display: none;
        }

        &:first-of-type {
          transform: rotate(90deg);
        }

        &:last-child {
          transform: rotate(-90deg);
        }
      }
    }

    .CalendarMonth_caption {
      font-size: ${size(14)};
      font-weight: 300;
      padding-bottom: ${size(40)};
    }

    .DayPicker_weekHeader {
      top: 54px;
      color: ${props => `${props.styles.textColor}`};

      small {
        font-weight: 600;
      }
    }

    .CalendarDay {
      border: none !important;
      outline: none !important;
      font-size: ${size(14)};
      box-shadow: inset 0px 2px 0px 0px #ffffff, inset 0px -2px 0px 0px #ffffff;

      &.CalendarDay__selected,
      &.CalendarDay__selected_span,
      &.CalendarDay__hovered_span,
      &.CalendarDay__hovered_span:hover,
      &:hover {
        background: ${props => `${props.styles.dayColor}`};
        color: ${props => `${props.styles.textColor}`};
      }

      &.CalendarDay__selected_span {
        &.CalendarDay__firstDayOfWeek {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }

        &.CalendarDay__lasttDayOfWeek {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
      }

      &.CalendarDay__selected_start {
        border-top-left-radius: 100px !important;
        border-bottom-left-radius: 100px !important;
        box-shadow: inset 2px 2px 0px 0px #ffffff, inset 2px -2px 0px 0px #ffffff;
      }

      &.CalendarDay__selected_end {
        border-top-right-radius: 100px !important;
        border-bottom-right-radius: 100px !important;
        box-shadow: inset -2px 2px 0px 0px #ffffff, inset -2px -2px 0px 0px #ffffff;
      }

      &.CalendarDay__selected_start.CalendarDay__selected_end {
        background: none;
      }

      &.CalendarDay__selected_start,
      &.CalendarDay__selected_end {
        position: relative;
        z-index: 0;
        color: #fff;

        &::before {
          content: '';
          position: absolute;
          width: 24px;
          height: 24px;
          background: ${props => `${props.styles.selectedColor}`};
          top: 4px;
          left: 4px;
          z-index: -1;
          border-radius: 100%;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.31);
        }
      }
    }
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: ${size(128)};
  padding: ${size(40)} ${size(16)};
  border-right: ${props => `1px solid ${props.styles.borderColor}`};
  height: 100%;

  .range-datepicker-option {
    margin-bottom: ${size(12)};
    cursor: pointer;

    &:hover,
    &.is-selected {
      color: ${props => `${props.styles.selectedColor}`};
    }
  }
`;
